module.exports = __webpack_public_path__ + "static/media/video-gallery.ffca83c5.png";